import { render, staticRenderFns } from "./CalendarResourceEdit.vue?vue&type=template&id=a1ae45c8&scoped=true"
import script from "./CalendarResourceEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarResourceEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CalendarResourceEdit.vue?vue&type=style&index=0&id=a1ae45c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ae45c8",
  null
  
)

export default component.exports